import * as React from 'react'
import Badge from './components/Badge'
import { LinkMenu } from './components/LinkMenu'
import { BalloonHint } from './components/BalloonHint'
import { BadgeProps } from './types'
import { DefaultBadgeProps } from './defaults'

const applyDefaultValues = (declaredValues: any, defaultValues: any) => {
  const newValues = { ...defaultValues, ...declaredValues }
  Object.keys(newValues).forEach((key) => {
    if (
      typeof defaultValues[key] === 'object' &&
      !(defaultValues[key] instanceof Array)
    ) {
      newValues[key] = applyDefaultValues(
        declaredValues ? declaredValues[key] : {},
        defaultValues[key]
      )
    }
  })
  return newValues
}

const FloatingBadge = (props: BadgeProps) => {
  const {
    height,
    margin,
    position,
    showHint,
    hintTheme,
    hintContents,
    menuTheme,
    menu,
    ...badgeProps
  } = applyDefaultValues(props, DefaultBadgeProps)

  const [openCTA, setCTAState] = React.useState(false)

  const { loading, menuEnabled } = badgeProps
  const handleClick = () => {
    if (!loading && menuEnabled) {
      setCTAState(!openCTA)
    }
  }
  if (showHint && openCTA) {
    setCTAState(false)
  }

  return (
    <div>
      {openCTA && menuEnabled && !showHint && (
        <LinkMenu
          position={position}
          badgeHeight={height}
          badgeMargin={margin}
          menuCloseCallback={() => setCTAState(false)}
          {...{ ...menu, ...menuTheme }}
        />
      )}
      <Badge
        height={height}
        margin={margin}
        position={position}
        menuWidth={menuTheme.width}
        bottomBarColor={menuTheme.bottomBarColor}
        {...badgeProps}
        onClick={handleClick}
        openCTA={openCTA && !showHint}
      />
      {showHint && hintContents && (
        <BalloonHint
          parentHeight={height}
          parentOffset={margin}
          {...{
            ...hintTheme,
            position,
            hintContents
          }}
        />
      )}
    </div>
  )
}

export default FloatingBadge
export * from './types'
